export const loadImage = (name: string): string => {
  return require('@/assets/images/' + name + '.png');
};

export const getDoubleDimensional = <T>(list: T[], count: number) => {
  const result = [];

  for (let i = 0; i < list?.length; i += count) {
    result.push(list.slice(i, i + count));
  }
  return result;
};

export const getSrc = (name: string) => {
  return `https://cdn-digital.ssv.qq.com/upload/${name}.png`;
};
export { getBr } from '@/app/domain/components/text-utils';

export const isEmail = (str: string) => {
  const reg =
    /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
  return reg.test(str);
};

interface IndexedItem {
  _reealIndex: number;
}
/**
 * 将数组按指定分组数进行模运算分组
 * @param {T[]} array - 待分组的原始数组
 * @param {number} groupCount - 分组数量
 * @returns {T[][]} 分组后的二维数组，每个子数组包含原始数组中对应模数的元素
 * @throws {Error} 当分组数小于等于0时返回空数组
 */
export function convertGroupByMod<T>(
  array: T[],
  groupCount: number
): (T & IndexedItem)[][] {
  if (groupCount <= 0 || array.length === 0) {
    return [];
  }

  // 初始化结果数组，注意类型是 (T & IndexedItem)[][]
  const result: (T & IndexedItem)[][] = Array.from(
    { length: groupCount },
    () => []
  );

  array.forEach((item, index) => {
    const groupIndex = index % groupCount;

    // 关键：使用类型断言 (as) 将 item 断言为 T & IndexedItem 类型
    // 这样我们就可以安全地添加 _reealIndex 属性
    const itemWithIndex = item as T & IndexedItem;
    itemWithIndex._reealIndex = index;

    result[groupIndex].push(itemWithIndex);
  });

  return result;
}
